import { API_BASE_URL } from "../config/api";

const BALANCE_KEY = "aio_wallet_balance_v1";
const HISTORY_KEY = "aio_wallet_history_v1";
const MIGRATED_KEY = "aio_wallet_server_migrated";

export const REWARD_AMOUNTS = [11, 21, 31, 41, 51, 61, 71, 81, 91, 101];

const SPECIAL_WALLET_MOBILE = "9152527030";
const SPECIAL_WALLET_BALANCE = 100000;

const wrap = (mobileNo) => {
  const m = String(mobileNo || "").replace(/\D/g, "").slice(-10);
  return m ? `_${m}` : "";
};

const getStorageKeys = (mobileNo) => ({
  balanceKey: `${BALANCE_KEY}${wrap(mobileNo)}`,
  historyKey: `${HISTORY_KEY}${wrap(mobileNo)}`,
});

const parseNum = (v) => {
  const n = parseFloat(v);
  return isNaN(n) ? 0 : n;
};

const getMobile = () => localStorage.getItem("userMobileNumber") || "";

// Sync (cache) read — instant display ke liye. Server value syncBalance se aati hai.
export const getBalance = (mobileNo) => {
  const m = mobileNo || getMobile();
  const { balanceKey } = getStorageKeys(m);
  const raw = localStorage.getItem(balanceKey);
  if (raw !== null) return parseNum(raw);
  if (wrap(m) === wrap(SPECIAL_WALLET_MOBILE)) {
    localStorage.setItem(balanceKey, String(SPECIAL_WALLET_BALANCE));
    return SPECIAL_WALLET_BALANCE;
  }
  return 0;
};

export const getHistory = (mobileNo) => {
  const m = mobileNo || getMobile();
  const { historyKey } = getStorageKeys(m);
  try {
    const raw = localStorage.getItem(historyKey);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
};

const persistHistory = (historyKey, list) => {
  localStorage.setItem(historyKey, JSON.stringify(list.slice(0, 100)));
};

const pushLocalHistory = (m, entry) => {
  const { historyKey } = getStorageKeys(m);
  persistHistory(historyKey, [
    {
      id: `${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
      date: new Date().toISOString(),
      ...entry,
    },
    ...getHistory(m),
  ]);
};

// One-time migration: purana local wallet balance server pe bhej do (agar server pe 0 ho).
const migrateLocalToServer = async (m) => {
  const migratedKey = `${MIGRATED_KEY}${wrap(m)}`;
  if (localStorage.getItem(migratedKey)) return;
  try {
    const { balanceKey } = getStorageKeys(m);
    const localBal = parseNum(localStorage.getItem(balanceKey));
    if (localBal > 0) {
      const res = await fetch(`${API_BASE_URL}/Wallet/GetBalance?mobileNo=${encodeURIComponent(m)}`);
      const data = await res.json().catch(() => null);
      const serverBal = data?.success ? parseNum(data.balance) : 0;
      if (serverBal <= 0) {
        await fetch(`${API_BASE_URL}/Wallet/Add`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ MobileNo: m, Amount: localBal, Note: "Local wallet se migrate" }),
        });
      }
    }
  } catch {}
  localStorage.setItem(migratedKey, "1");
};

// Server se balance lao aur cache update karo.
export const syncBalance = async (mobileNo) => {
  const m = mobileNo || getMobile();
  if (!m) return 0;
  try {
    await migrateLocalToServer(m);
    const res = await fetch(`${API_BASE_URL}/Wallet/GetBalance?mobileNo=${encodeURIComponent(m)}`);
    const data = await res.json().catch(() => null);
    if (data?.success) {
      const bal = parseNum(data.balance);
      const { balanceKey } = getStorageKeys(m);
      localStorage.setItem(balanceKey, String(bal));
      window.dispatchEvent(new Event("wallet:updated"));
      return bal;
    }
  } catch {}
  return getBalance(m);
};

// Credit — server pe add hota hai (source of truth), local cache update.
export const credit = async (amount, note) => {
  const m = getMobile();
  const amt = parseNum(amount);
  if (!amt || amt <= 0) return { success: false, reason: "invalid-amount" };
  try {
    const res = await fetch(`${API_BASE_URL}/Wallet/Add`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ MobileNo: m, Amount: amt, Note: note || "Wallet recharge" }),
    });
    const data = await res.json().catch(() => null);
    if (!res.ok || !data?.success) throw new Error(data?.message || "Credit failed");
    const balance = parseNum(data.balance);
    const { balanceKey } = getStorageKeys(m);
    localStorage.setItem(balanceKey, String(balance));
    pushLocalHistory(m, { type: "credit", amount: amt, note: note || "Wallet recharge", balance });
    window.dispatchEvent(new Event("wallet:updated"));
    return { success: true, balance };
  } catch (e) {
    return { success: false, reason: "server-error", message: e.message };
  }
};

// Debit — server pe balance check hoke minus hota hai, local cache update.
export const debit = async (amount, note) => {
  const m = getMobile();
  const amt = parseNum(amount);
  if (!amt || amt <= 0) return { success: false, reason: "invalid-amount" };
  try {
    const res = await fetch(`${API_BASE_URL}/Wallet/Spend`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ MobileNo: m, Amount: amt, Note: note || "Wallet payment" }),
    });
    const data = await res.json().catch(() => null);
    if (!res.ok || !data?.success) {
      if (res.status === 400 && /balance/i.test(data?.message || "")) {
        return { success: false, reason: "insufficient-balance", balance: parseNum(data?.balance) };
      }
      throw new Error(data?.message || "Debit failed");
    }
    const balance = parseNum(data.balance);
    const { balanceKey } = getStorageKeys(m);
    localStorage.setItem(balanceKey, String(balance));
    pushLocalHistory(m, { type: "debit", amount: amt, note: note || "Wallet payment", balance });
    window.dispatchEvent(new Event("wallet:updated"));
    return { success: true, balance };
  } catch (e) {
    return { success: false, reason: "server-error", message: e.message };
  }
};

export const UPI_VPA = "9152527030ss-3@okhdfcbank";
export const UPI_PAYEE_NAME = "AIO INDIA";

export const buildUPIUri = ({ amount, note, txnRef }) => {
  const params = {
    pa: UPI_VPA,
    pn: UPI_PAYEE_NAME,
    am: String(amount),
    cu: "INR",
    tn: note || "Wallet Top-up",
  };
  if (txnRef) params.tr = txnRef;
  return (
    "upi://pay?" +
    Object.entries(params)
      .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
      .join("&")
  );
};

export const makeTxnRef = (mobileNo) => {
  const m = String(mobileNo || "").replace(/\D/g, "").slice(-10);
  return `AIO${m}${Date.now()}`;
};
